module.exports = __webpack_public_path__ + "static/media/seed1.e7850cf1.png";